<template>
  <div>
    <form id="upload-form">
      <input
        type="file"
        name="avatar"
        ref="fileInput"
        id="file-input"
        accept="image/*"
        @change="handleFileSelect"
        style="visibility: hidden; width: 0"
      />
      <el-button
        class="upload-btn"
        id="upload-btn"
        plain
        type="success"
        @click="clickChangeImg"
      >
        选择图片
      </el-button>
      <el-button
        class="upload-btn"
        style="margin: 10px 0 0"
        plain
        type="primary"
        @click="open = true"
      >
        拍照
      </el-button>
      <div id="image-container" style="display: none"></div>
      <div id="edit-controls" style="margin: 10px 0; display: none">
        <el-button
          class="rotate-btn"
          type="primary"
          plain
          round
          id="rotate-btn"
          @click="rotate(90)"
        >
          旋转
        </el-button>
        <el-button
          class="rotate-left-btn"
          type="primary"
          plain
          round
          id="rotate-left-btn"
          @click="rotate(-1)"
        >
          <!-- 左旋转1° -->
          <el-icon><RefreshLeft /></el-icon>
        </el-button>
        <el-button
          class="rotate-right-btn"
          type="primary"
          plain
          round
          id="rotate-right-btn"
          @click="rotate(1)"
        >
          <!-- 右旋转1° -->
          <el-icon><RefreshRight /></el-icon>
        </el-button>
        <!-- <div class="scope-btn">
          <el-icon><InfoFilled /></el-icon>
        </div> -->

        <div class="direction-pad">
          <div
            class="direction-btn top"
            @click="move(0, -1)"
            id="direction-btn-top"
          >
            <el-icon :size="20" color="#409EFF">
              <ArrowUpBold />
            </el-icon>
          </div>
          <div
            class="direction-btn left"
            @click="move(-1, 0)"
            id="direction-btn-left"
          >
            <el-icon :size="20" color="#409EFF">
              <ArrowLeftBold />
            </el-icon>
          </div>
          <div
            class="direction-btn center"
            @click="uploadFile"
            id="direction-btn-center"
          >
            <div class="upload-btn" :class="{ 'is-uploading': isUploading }">
              {{ isUploading ? '上传中...' : '上传' }}
            </div>
          </div>
          <div
            class="direction-btn right"
            @click="move(1, 0)"
            id="direction-btn-right"
          >
            <el-icon :size="20" color="#409EFF">
              <ArrowRightBold />
            </el-icon>
          </div>
          <div
            class="direction-btn bottom"
            @click="move(0, 1)"
            id="direction-btn-bottom"
          >
            <el-icon :size="20" color="#409EFF">
              <ArrowDownBold />
            </el-icon>
          </div>
        </div>
      </div>
    </form>
    <div id="result-container">
      <div class="footer">
        <div class="footer-content">
          <div class="footer-title">{{ resultText }}</div>
          <div class="footer-info">
            <div>
              总槽数:{{ result.detected_regions }}
              <el-tooltip
                :visible="showText"
                content="没算准？看看使用说明吧！"
                placement="top"
                effect="light"
              >
                <span class="footer-icon" id="staticUseBtn" @click="openImg">
                  <el-icon><QuestionFilled /></el-icon>
                </span>
              </el-tooltip>
              <el-badge :is-dot="dotFlag" class="item">
                <span class="footer-icon" @click="openVideo" id="dynUseBtn">
                  <el-icon><VideoPlay /></el-icon>
                </span>
              </el-badge>
              <el-tooltip
                :visible="showText"
                content="反馈问题"
                placement="top"
                effect="light"
              >
                <span class="footer-icon" id="staticUseBtn" @click="openErCode">
                  <el-icon><ChatLineSquare /></el-icon>
                </span>
              </el-tooltip>
            </div>
          </div>
          <div>
            <el-image
              style="width: 100%; height: 200px"
              :src="result.upload"
              :preview-src-list="result.upload"
            >
              <template #error>
                <div class="el-image__error">等待识别</div>
              </template>
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-warp">
      <a href="https://beian.miit.gov.cn/" target="_blank">
        备案号:京ICP备2025121192号-1
      </a>
    </div>
    <cameraPage v-if="open" @close="open = false" @photoFile="onPhoto" />
    <el-dialog
      v-model="centerDialogVisible"
      title="使用说明"
      width="80%"
      align-center
    >
      <el-image
        style="width: 100%; height: 100%"
        :src="url"
        :zoom-rate="1.2"
        :preview-src-list="url"
        :initial-index="4"
        fit="cover"
      />
    </el-dialog>
    <el-dialog
      v-model="videoDialogVisible"
      title="使用操作说明"
      width="80%"
      align-center
    >
      <video
        controls
        autoplay
        style="width: 100%; max-height: 70vh"
        :src="videoUrl"
      />
    </el-dialog>
    <el-dialog
      v-model="erDialogVisible"
      title="反馈问题"
      width="80%"
      align-center
    >
      <el-image
        style="width: 100%; height: 100%"
        :src="erUrl"
        :zoom-rate="1.2"
        :preview-src-list="erUrl"
        :initial-index="4"
        fit="cover"
      />
    </el-dialog>
    <el-dialog
      v-model="centerDialogVisible"
      title="使用说明"
      width="80%"
      align-center
    >
      <el-image
        style="width: 100%; height: 100%"
        :src="url"
        :zoom-rate="1.2"
        :preview-src-list="url"
        :initial-index="4"
        fit="cover"
      />
    </el-dialog>

    <el-dialog
      v-model="videoDialogVisible"
      title="使用视频说明"
      width="80%"
      align-center
    >
      <video
        controls
        autoplay
        style="width: 100%; max-height: 70vh"
        :src="videoUrl"
      />
    </el-dialog>
  </div>
</template>

<script>
  import cameraPage from '@/views/cutterPage/components/cameraPage.vue'
  export default {
    components: { cameraPage },
    data() {
      return {
        open: false,
        currentImage: null,
        cropper: null,
        showText: false,
        isUploading: false, // 新增上传状态标志
        result: {
          url: '',
          detected_regions: 0
        },
        resultText: '计算结果',
        centerDialogVisible: false,
        erDialogVisible: false,
        videoDialogVisible: false,
        videoUrl:
          'https://silicon-1256171973.cos.ap-guangzhou.myqcloud.com/static/demo.mp4',
        url: 'https://silicon-1256171973.cos.ap-guangzhou.myqcloud.com/static/demo1.png',
        erUrl: 'https://silicon-1256171973.cos.ap-guangzhou.myqcloud.com/static/company-code.png',
        dotFlag: true
      }
    },
    mounted() {
      if (typeof _hmt !== 'undefined') {
        _hmt.push(['openCorpperPage', this.$route.path])
      }
    },
    methods: {
      onPhoto(img) {
        this.open = false
        this.handleFileSelect(img, true)
      },
      clickChangeImg() {
        //   document.getElementById('file-input').click();
        this.$refs.fileInput.click()
      },
      openImg() {
        if (typeof _hmt !== 'undefined') {
          _hmt.push(['openImg', 'button', 'click', 'openImgBtn'])
        }
        this.centerDialogVisible = true
      },
      openErCode() {
        this.erDialogVisible=true;
      },
      openVideo() {
        if (typeof _hmt !== 'undefined') {
          _hmt.push(['openVideo', 'button', 'click', 'openVideoBtn'])
        }
        this.dotFlag = false
        this.videoDialogVisible = true
      },
      showEditControls() {
        document.getElementById('edit-controls').style.display = 'block'
      },
      handleFileSelect(event, isCamera) {
        if (typeof _hmt !== 'undefined') {
          _hmt.push(['selectedFile', 'button', 'click', 'selectedFileBtn'])
        }
        const file = isCamera ? event : event.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = e => {
            const imageContainer = document.getElementById('image-container')
            imageContainer.innerHTML = ''

            this.currentImage = file
            // this.currentImage.src = e.target.result

            const img = document.createElement('img')
            img.id = 'cropper-image'
            img.src = e.target.result
            imageContainer.appendChild(img)
            imageContainer.style.display = 'block'

            this.cropper = new Cropper(img, {
              aspectRatio: 16 / 5, // 裁剪比例，NaN表示不固定比例
              viewMode: 0, // 视图模式：0-无限制，1-限制裁剪框不超过图片大小
              dragMode: 'move', // 拖动模式：'crop'-裁剪，'move'-移动，'none'-无
              canScale: false, // 是否允许缩放图片
              // autoCropArea: 0.8, // 自动裁剪区域占图片的比例
              responsive: true, // 是否响应式调整裁剪框
              rotatable: true, // 是否允许旋转图片
              scalable: true, // 是否允许缩放图片
              zoomable: true, // 是否允许放大图片
              cropBoxResizable: false, // 是否允许调整裁剪框大小
              cropBoxMovable: true, // 允许移动裁剪框
              cropperBoxResizable: false, // 允许调整裁剪框大小
              toggleDragModeOnDblclick: false, // 双击是否切换拖动模式
              checkCrossOrigin: false, // 是否检查跨域图片
              background: false, // 是否显示背景
              guides: false, // 是否显示辅助线
              highlight: true, // 是否高亮裁剪框
              // minContainerWidth: window.innerWidth * 0.8,  // 屏幕宽度的80%
              // minContainerHeight: window.innerHeight * 0.6,  // 屏幕高度的60%
              touchAction: 'move', // 触摸行为
              wheelZoomRatio: 0.1, // 鼠标滚轮缩放比例
              ready: function () {
                //   this.cropper.setDragMode('none');
                let containerWidth =
                    document.getElementById('image-container').offsetWidth,
                  containerHeight =
                    document.getElementById('image-container').offsetHeight
                this.cropper.setCropBoxData({
                  width: containerWidth * 0.8,
                  // height : containerHeight * 0.6,
                  left: (containerWidth - containerWidth * 0.8) / 2 // 计算水平居中位置
                  // top : (containerHeight - containerHeight * 0.6) / 2   // 计算垂直居中位置
                })
              }
            })

            this.showEditControls()
          }
          reader.readAsDataURL(file)
        }
      },
      rotate(degree) {
        this.cropper.rotate(degree)
      },
      move(x, y) {
        this.cropper.move(x, y)
      },
      uploadFile() {
        if (typeof _hmt !== 'undefined') {
          _hmt.push(['FileUpload', 'button', 'click', 'FileUploadBtn'])
        }
        if (this.isUploading) return // 如果正在上传，直接返回
        if (!this.cropper) {
          alert('请先选择图片')
          return
        }

        this.isUploading = true // 设置上传状态
        this.resultText = '正在计算...'

        const canvas = this.cropper.getCroppedCanvas({
          width: 800,
          height: 800,
          minWidth: 256,
          minHeight: 256,
          maxWidth: 4096,
          maxHeight: 4096,
          fillColor: '#fff',
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high'
        })

        if (!canvas) {
          this.isUploading = false // 重置上传状态
          alert('请先选择截图区域')
          return
        }
        this.uploadOriginalImage()

        canvas.toBlob(
          blob => {
            const formData = new FormData()
            formData.append('avatar', blob, 'cropped_image.jpg')

            fetch('https://www.siliconapp.cn/upload', {
              method: 'POST',
              body: formData
            })
              .then(response => response.json())
              .then(data => {
                this.resultText = '计算结果'
                this.showText = true
                if (data) this.result = { ...data.data }
                else {
                  alert(data.error)
                }
              })
              .catch(error => {
                this.resultText = '计算结果'
                console.error('上传发生错误:', error)
                alert('上传失败')
              })
              .finally(() => {
                this.isUploading = false // 无论成功失败，都重置上传状态
              })
          },
          'image/jpeg',
          0.9
        )
      },
      uploadOriginalImage() {
        const formData = new FormData()
        //原图
        formData.append('originalPic', this.currentImage)
        fetch('https://www.siliconapp.cn/uploadImage', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            //成功提交
          })
          .catch(error => {
            //提交失败
          })
          .finally(() => {})
      }
    }
  }
</script>

<style scoped lang="scss">
  .direction-pad {
    position: relative;
    width: 170px;
    height: 170px;
    margin: 10px auto;
    border-radius: 50%;
    background: #f5f7fa;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .direction-btn {
      position: absolute;
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.3s;

      &:active {
        box-shadow:
          inset 2px 2px 5px #bebebe,
          inset -2px -2px 5px #ffffff;
      }

      &.center {
        background: linear-gradient(145deg, #ffffff, #e6e6e6);
        box-shadow:
          3px 3px 6px #bebebe,
          -3px -3px 6px #ffffff;
        .upload-btn {
          width: 100%;
          height: 100%;
          line-height: 60px;
          border-radius: 50%;
          background: rgb(64, 158, 255);
          color: white;
          transition: all 0.3s;

          &.is-uploading {
            background: #a0cfff;
            cursor: not-allowed;
          }
        }
        &:active {
          box-shadow:
            inset 2px 2px 5px #5aad33,
            inset -2px -2px 5px #74d240;
        }
      }
      &:hover {
        transform: scale(1.1);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      }

      &.top {
        top: -4px;
        left: 50%;
        transform: translateX(-50%);
      }
      &.left {
        top: 50%;
        left: -4px;
        transform: translateY(-50%);
      }
      &.center {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
      }
      &.right {
        top: 50%;
        right: -4px;
        transform: translateY(-50%);
      }
      &.bottom {
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .bottom-warp {
    bottom: 0;
    margin: 0 auto;
    left: 0;
    right: 0;
    font-size: 10px;
  }
  h1 {
    text-align: center;
    width: 100%;
    margin: 10px auto;
    font-size: 1.5rem;
  }
  .upload-btn {
    width: 90%;
  }
  #result-container {
    margin: 30px auto 0;
  }
  #image-container {
    width: 90%;
    height: 70vh;
    margin: 10px auto;
  }
  .footer {
    margin-top: 20px;
    .footer-content {
      border-top: 1px solid #eee;
      .footer-title {
        padding: 0 10px;
        background: #fff;
        position: relative;
        top: -14px;
        display: inline-block;
      }

      .footer-info {
        position: relative;
        .footer-icon {
          font-size: 16px;
          color: #409eff;
          margin-left: 10px;
          // animation: subtlePulse 2s ease-in-out infinite;
          // @keyframes subtlePulse {
          //   0%,
          //   100% {
          //     opacity: 1;
          //   }
          //   50% {
          //     opacity: 0.3;
          //   }
          // }
        }
      }
    }
  }

  ::v-deep .cropper-center:before {
    background-color: #409eff;
    width: 13px;
    left: -6px;
  }
  ::v-deep .cropper-center:after {
    background-color: #409eff;
    height: 13px;
    top: -6px;
  }
  #edit-controls {
    flex-direction: column;
    padding: 0 5px;
    position: relative;
    .rotate-btn {
      position: absolute;
      top: 0.5rem;
      left: 1.5rem;
    }

    .rotate-left-btn {
      position: absolute;
      bottom: 0.5rem;
      left: 1.5rem;
    }
    .rotate-right-btn {
      position: absolute;
      bottom: 0.5rem;
      right: 1.5rem;
    }
    .el-button {
      margin: 5px;
    }
  }

  @media (max-width: 767px) {
    #image-container {
      /* height: 100%; */
      height: 300px;
      margin: 0;
      flex: 1 1 auto;
    }
    #edit-controls button {
      padding: 12px;
      margin: 8px 0;
      font-size: 0.9rem;
    }
    body {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }
    #result-container {
      flex-grow: 1;
    }
  }
  @media (min-width: 768px) {
    #result-container,
    #image-container {
      width: 600px;
    }
    #edit-controls button {
      flex: none;
      padding: 10px 15px;
    }
  }
  #preview-image {
    max-width: 100%;
    margin-top: 20px;
  }
  #image-container {
    flex: 1;
    width: 100%;
    height: 300px;
    margin: 10px 0;
    overflow: hidden;
    touch-action: none;
  }
  .video-dialog {
    .el-message-box__content {
      padding: 0;
    }
    .el-message-box__header {
      padding: 20px;
    }
  }
</style>
